import path from "path";

export const getNavigation = (t: any) => [

  {
    text: t('Customer'),
    icon: 'group',
    path:'',
    items: [
      {
    text: t('customer'),
    
    path: '/customer',
    items: [],
  }
]
  },
  {
    text: t('vehicles'),
    icon: 'car',
    path: '/vehicles',
    items: [],
  },
   {
    text: t('Routes'),
    icon: 'map',
    path: '/routes',
    items: [],
  },
  {
    text: t('settings'),
    icon: 'optionsgear',
    path: '',
    items: [
          {
    text: t('theme'),
    
    path: '/theme',
    items: [],
  }
    ],
  }

];
